let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("g7KP5")).then(() => parcelRequire('5fnPe'));